"use client";

import { FC, memo } from "react";
import { DesktopProposalTable } from "./DesktopProposalTable";
import { ProposalTableComponentProps } from "../lib/type";
import { useMediaQuery } from "@mui/material";
import { BreakPointsPx } from "@/src/shared/const";
import { ProposalTableProvider } from "./ProposalTableProvider";
import { MobileProposalTable } from "./MobileProposalTable";

export const ProposalTable: FC<ProposalTableComponentProps> = memo((props) => {
  const isMobile = useMediaQuery(`(max-width: ${BreakPointsPx.mdPlus})`);
  console.log("props", props);
  return (
    <ProposalTableProvider {...props}>
      {isMobile ? <MobileProposalTable /> : <DesktopProposalTable />}
    </ProposalTableProvider>
  );
});

ProposalTable.displayName = "ProposalTable";
